import alt from '../alt';


class TimezoneActions {
    constructor() {
        this.generateActions('getTimezonesSuccess');
    }

}

export default alt.createActions(TimezoneActions);



/** WEBPACK FOOTER **
 ** ./app/src/actions/TimezoneActions.js
 **/